module.exports = __webpack_public_path__ + "static/media/Trade_History.109c8463.PNG";